export default word => {
  var words = word.split(" ");
  if (word) {
    if (words.length > 2) {
      return `search[firstName]=${words[0]}&search[lastName]=${words[1]}&search[lastName]=${words[2]}&search[email]=${word}`;
    } else if (words.length == 2) {
      return `search[firstName]=${words[0]}&search[lastName]=${words[1]}&search[email]=${word}`;
    } else {
      return `search[firstName]=${word}&search[lastName]=${word}&search[email]=${word}`;
    }
  }
  return "orderBy=lastName:ASC";
};
